<template>
  <div class="grid">
    <div v-for="i in company" :key="i">
      <Card :info="i" />
    </div>
  </div>
</template>

<script>
import Card from '../../components/core/Homev2/card.vue'
export default {
  components: {
    Card,
  },
  data() {
    return {
      company: [
        // {
        //   title: 'Executive brand acquisition ',
        //   level: 'Entry Level',
        //   salary: 'BDT 15-20k + Commission / Month',
        //   link: '/dealone',
        //   company: 'dealone',
        //   img: require('../../assets/AssementLanding/Company_Logo/Screenshot 2022-03-23 135549.png'),
        // },
        // {
        //   title: 'Golang Developer ',
        //   level: 'Mid Level',
        //   salary: 'BDT 125-250k / Month',
        //   link: '/shikho',
        //   company: 'Shikho',
        //   img: require('../../assets/AssementLanding/Company_Logo/Screenshot 2022-03-22 051101.png'),
        // },
        // {
        //   title: 'Golang Developer ',
        //   level: 'Junior',
        //   salary: 'Negotiable',
        //   link: '/shikho-golang',
        //   company: 'Shikho',
        //   img: require('../../assets/AssementLanding/Company_Logo/Screenshot 2022-03-22 051101.png'),
        // },
        // {
        //   title: 'Laravel Developer',
        //   level: 'Mid Level',
        //   salary: 'BDT 40-60k / Month',
        //   link: '/aventraLaravel',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Frontend Developer',
        //   level: 'Mid Level',
        //   salary: 'BDT 200-280k / Month',
        //   link: '/docspace',
        //   company: 'DocSpace',
        //   img: require('../../assets/AssementLanding/Company_Logo/Screenshot 2022-04-11 124218.png'),
        // },
        // {
        //   title: 'Product Owner ',
        //   level: 'Mid level',
        //   salary: 'Negotiable',
        //   link: '/bongoProductOwner',
        //   company: 'Bongo',
        //   img: require('../../assets/bongo/copywriter-content-planner-Magnito-Digital.png'),
        // },
        // {
        //   title: 'Product Designer ',
        //   level: 'Mid level',
        //   salary: 'BDT 30-55k / Month',
        //   link: '/trucklagbe',
        //   company: 'Truck Lagbe',
        //   img: require('../../assets/bongo/ipage-isa-flutter.png'),
        // },
        // {
        //   title: 'Senior Backend Developer ',
        //   level: 'Mid Level',
        //   salary: 'BDT 80-100k / Month',
        //   link: '/greeho',
        //   company: 'Greeho',
        //   img: require('../../assets/telmax/greeho.png'),
        // },
        // {
        //   title: 'PRODUCT DESIGNER (Remote) ',
        //   level: 'Mid Level',
        //   salary: 'USD $4000-$5000 / Month',
        //   link: '/pluto',
        //   company: 'Pluto',
        //   img: require('../../assets/telmax/pluto.png'),
        // },
        // {
        //   title: 'Ios Developer',
        //   level: 'Mid Level',
        //   salary: 'BDT 40-60k / Month',
        //   link: '/aventraIos',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Financial Analyst ',
        //   level: 'Mid Level',
        //   salary: 'BDT 50-100k / Month',
        //   link: '/cmedFinance',
        //   company: 'CMED',
        //   img: require('../../assets/telmax/cmed.png'),
        // },
        // {
        //   title: 'UI/UX designer',
        //   level: 'Mid Level',
        //   salary: 'BDT 40-60k / Month',
        //   link: '/aventraUXUI',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Senior Network Administrator ',
        //   level: 'Senior Level',
        //   salary: 'BDT 40-60k',
        //   link: '/aventraNetwork',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Red Hat Certified Administrator',
        //   level: 'Mid Level',
        //   salary: 'BDT 40-60k / Month',
        //   link: '/aventraRedhat',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Senior Android Developer ',
        //   level: 'Mid Level',
        //   salary: 'BDT 40-60k / Month',
        //   link: '/aventraAndriod',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Human Resource Officer  ',
        //   level: 'Mid Level',
        //   salary: 'BDT 30k / Month',
        //   link: '/aventra',
        //   company: 'Aventra',
        //   img: require('../../assets/bongo/image1-removebg-preview.png'),
        // },
        // {
        //   title: 'Project Manager Role',
        //   level: 'Senior Level',
        //   salary: 'Negotiable',
        //   link: '/bongoProjectManager',
        //   company: 'Bongo',
        //   img: require('../../assets/bongo/ipage-isa-flutter.png'),
        // },
      ],
    }
  },
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  grid-gap: 30px;
  padding-bottom: 100px;
}
</style>
